



















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import LectureEntityFormItem from "@/components/lectures/LectureEntityFormItem.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import EditorWithFile from "@/components/EditorWithFile.vue";
import draggableComponent from "vuedraggable";
import api from "@/getinfo-api";
import { IAddPageParams } from "@/store/modules/lectures/lectures";
import { Sort as ISort } from "@/api/models/sort";
import { IPageSort } from "@/store/modules/lectures/lectures";
import FileManager from "@/components/files/FileManager.vue";
import { FileItem as IFileItem } from "@/api/models/file-item";

@Component({
  components: {
    LectureEntityFormItem,
    CustomButton,
    EditorWithFile,
    FileManager,
    draggableComponent
  }
})
export default class LectureEntityFormList extends Vue {
  @Prop() type?: string;
  @Prop() entities?: Array<any>;
  @Prop() lectureId?: string;
  modalId: string = this.generateModalId();
  body: string = "";
  entitiesList: Array<any> = [];
  entitiesFiles: Array<IFileItem> = [];
  images!: Array<string> | undefined;

  data() {
    return {
      images: undefined
    };
  }

  get entityType() {
    let apiMethod: any;
    if (this.type === "pages") {
      apiMethod = api.LecturePageApi;
    }
    return apiMethod;
  }

  get pages() {
    return this.$store.getters.LECTURE_PAGES;
  }

  get slides() {
    return this.$store.getters.LECTURE_SLIDES;
  }

  generateModalId(): string {
    return Math.random()
      .toString(36)
      .substring(7);
  }

  showModal() {
    this.$bvModal.show(this.modalId);
  }

  hideModal() {
    this.$bvModal.hide(this.modalId);
  }

  applySort() {
    if (this.lectureId) {
      let allSort: Array<ISort> = [];
      this.entitiesList.forEach(el => {
        let param: ISort = {
          id: el.id,
          sort: el.sort
        };
        allSort.push(param);
      });
      let sort: IPageSort = {
        lectureId: this.lectureId,
        pages: allSort
      };
      this.$store.dispatch("APPLY_PAGES_SORT", sort);
    }
  }

  deleteEntity(item: any) {
    if (!item.id) {
      this.entitiesList = this.entitiesList.filter(el => el !== item);
    }
  }

  addFile(item: IFileItem) {
    this.entitiesFiles.push(item);
  }

  deleteFile(item: IFileItem) {
    this.entitiesFiles = this.entitiesFiles.filter(el => el !== item);
  }

  saveEntity() {
    if (!this.lectureId) {
      let param;
      if (this.type === "pages") {
        param = {
          body: this.body,
          images: this.images ? this.images : undefined
        };
      }

      this.entitiesList.push(param);
      this.body = "";
      this.entitiesFiles = [];
      this.hideModal();
    } else {
      let params: IAddPageParams = {
        lectureId: this.lectureId,
        body: {
          body: this.body,
          sort: this.entitiesList.length ? this.entitiesList.length + 1 : 1
        }
      };
      this.$store.dispatch("ADD_LECTURE_PAGE", params).then(() => {
        this.body = "";
        this.hideModal();
      });
    }
  }

  addPages() {
    if (this.lectureId) {
      this.entitiesList = this.pages?.length
        ? [...this.pages]
        : this.entitiesList;
    }
  }

  @Watch("entitiesList")
  updateEntitiesInCreate() {
    if (!this.lectureId) {
      this.$emit("getEntitiesList", this.entitiesList);
    }
  }

  @Watch("pages")
  getEnt() {
    this.addPages();
  }

  created() {
    this.addPages();
  }
}
